module.exports = __webpack_public_path__ + "static/media/icon_close.b885dd9c.svg";